<template>
  <div class="sy-data-board">
    <!-- 上虞数据展板头部 -->
    <div class="sy-data-board-top">
      <div class="sy-data-board-top-title">
        <!-- <div class="title">上虞区教育局大数据展板-教学运维</div> -->
        <div class="title">教学运维</div>
        <!-- <div class="left-btn">
          <div class="name">领导驾驶舱</div>
          <div class="name">教学数据</div>
        </div>
        <div class="right-btn">
          <div class="name">教师分析</div>
          <div class="name">学生分析</div>
        </div> -->
      </div>
      <div class="sy-data-board-top-full" v-on:click="handleFullScreen()">
        <span class="full-icon"><img :src="!fullscreen ? fullScreenIcon : exitFullScreenIcon" /></span>
        <span class="full-title">{{!fullscreen ? '全屏' : '取消全屏'}}</span>
      </div>
      <div class="sy-data-board-top-filter">
        <div class="filter-btn" @click="changeFilter('all')" :class="filterSelect == 'all' ? 'is-select' : ''">全部</div>
        <div class="filter-btn" @click="changeFilter('year')" :class="filterSelect == 'year' ? 'is-select' : ''">本学年</div>
        <div class="filter-btn" @click="changeFilter('month')" :class="filterSelect == 'month' ? 'is-select' : ''">本月</div>
      </div>
      <!-- 上虞区教育局大数据展板-教学数据 -->
    </div>
    <!-- 数据内容 -->
    <div class="sy-data-board-box">
        <!-- 左侧内容 -->
        <div class="sy-data-board-box-left">
            <!-- 教师备授课活跃排行Top10 -->
            <teach-active-rank :params="params"></teach-active-rank>
            <!-- 教师备授课教学行为分析 -->
            <teach-behavior-analysis :params="params"></teach-behavior-analysis>
        </div>
        <!-- 中间内容 -->
        <div class="sy-data-board-box-center">
          <teaching-dynamics :interactNumber="interactNumber" :examNumber="examNumber" :params="params" :quesNumber="quesNumber" :resTotal="resTotal" :activityNumber="activityNumber"></teaching-dynamics>
          <resource-construction @interact-number="getInteractNumber" :params="params"></resource-construction>
          <div class="sy-data-box-layout">
            <!-- 活动评审 -->
            <activity-review :params="params" @activity-number="getActivityNumber"></activity-review>
            <teaching-studio :params="params"></teaching-studio>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="sy-data-board-box-right">
          <!-- 精准教学 -->
          <precise-teach :params="params" @exam-number="getExamNumber"></precise-teach>
          <!-- 题库建设 -->
          <question-bank-build :params="params" @ques-number="getQuesNumber"></question-bank-build>
          <!-- 教研活动 -->
          <teach-activity :params="params"></teach-activity>
          <!-- 在线课程 -->
          <online-course :params="params"></online-course>
        </div>
    </div>
  </div>
</template>

<script>
import TeachActiveRank from "./modules/TeachActiveRank.vue"
import TeachBehaviorAnalysis from "./modules/TeachBehaviorAnalysis.vue"
import PreciseTeach from "./modules/PreciseTeach.vue"
import QuestionBankBuild from "./modules/QuestionBankBuild.vue"
import TeachActivity from "./modules/TeachActivity.vue"
import OnlineCourse from "./modules/OnlineCourse.vue"
import ResourceConstruction from "./modules/ResourceConstruction.vue"
import ActivityReview from "./modules/ActivityReview.vue"
import TeachingStudio from "./modules/TeachingStudio.vue"
import TeachingDynamics from "./modules/TeachingDynamics.vue"
export default {
  name: 'sy-data-board',
  components: {
    TeachActiveRank,
    TeachBehaviorAnalysis,
    PreciseTeach,
    QuestionBankBuild,
    TeachActivity,
    OnlineCourse,
    ResourceConstruction,
    ActivityReview,
    TeachingStudio,
    TeachingDynamics
  },
  data() {
    return {
      fullscreen:false,
      fullScreenIcon:require('@/assets/images/databoard/full-screen-icon.png'),
      exitFullScreenIcon:require('@/assets/images/databoard/exit-full-screen-icon.png'),
      filterSelect:'all',
      //活动评审数据统计
      activityReview:{
        topActivityReview:[]
      },
      params:{
        startTime:"",
        endTime:"",
        regionId:"dade959d4ced4f43b0a2d45878952c01"
        // regionId:"dcb893a0b487433ea13d1c225fc8dd9f"
      },
      //互动总数
      interactNumber:0,
      examNumber:0,
      quesNumber:0,
      activityNumber:0,
      resTotal:0
    }
  },
  methods: {
    /**
     * @name 获取互动总数
     */
    getInteractNumber(number,resTotal){
      this.interactNumber = number
      this.resTotal = resTotal
    },
    /**
     * @name  获取考试数
     */
    getExamNumber(number){
      this.examNumber = number
    },
    /**
     * @name 获取题库数
     */
    getQuesNumber(number){
      this.quesNumber = number;
    },
    /**
     * @name 获取评审数
     */
    getActivityNumber(number){
      this.activityNumber = number
    },
        /**
         * 全屏
         */
         handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        /**
         * @name 切换筛选
         */
        changeFilter(type){
          this.filterSelect = type;
          switch(type){
            case 'all':
              this.params.startTime = '';
              this.params.endTime = '';
              break;
            case 'year':
              //判断当前日期是在学年的前半段还是后半段
              let year = new Date().getFullYear();
              //当前时间大于学年开始时间，则处于学年的后半段
              if (new Date().getTime() < new Date(`${year}-08-10 00:00:00`).getTime()) {
                this.params.startTime = `${year - 1 }-08-10 00:00:00`;
                this.params.endTime = `${year}-08-09 23:59:59`
              } else {
                this.params.startTime = `${year}-08-10 00:00:00`;
                this.params.endTime = `${year + 1}-08-09 23:59:59`
              }
              break;
            case 'month':
              this.params.startTime = this.$utils.getMonthStartDate();
              this.params.endTime = this.$utils.getMonthEndDate();
              break
          }
        },
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.sy-data-board{
    background: rgb(6,17,52);
    width: 100%;
    height: auto;
    min-height: 100%;
    .sy-data-board-top{
        color: #fff;
        height: 126px;
        width: 100%;
        position: relative;
        background: rgba(6, 17, 52, 0.8);
        .sy-data-board-top-title{
          // width: calc(100% - 200px);
          width: 1690px;
          height: 95px;
          margin: 0 auto;
          background: url('../../assets/images/sydataboard/头部背景图.png') no-repeat;
          background-size: 100% 100%;
          text-align: center;
          position: relative;
          .title{
            display: inline-block;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
            margin-top: 20px;
          }
          .left-btn{
            position: absolute;
            left: 70px;
            display: flex;
            top: 25px;
            .name{
              width: 170px;
              height: 45px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(255,255,255,0.5);
              background: url('../../assets/images/sydataboard/模块切换.png') no-repeat;
              background-size: 100% 100%;
              margin-right:20px;
              cursor: pointer;
            }
          }
          .right-btn{
            position: absolute;
            right: 70px;
            display: flex;
            top: 25px;
            .name{
              width: 170px;
              height: 45px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(255,255,255,0.5);
              background: url('../../assets/images/sydataboard/模块切换.png') no-repeat;
              background-size: 100% 100%;
              margin-left:20px;
              cursor: pointer;
            }
          }
        }
        .sy-data-board-top-full{
          position: absolute;
          right: 20px;
          bottom: 40px;
          cursor: pointer;
          .full-title{
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #2773E6;
            margin-left: 5px;
          }
        }
        .sy-data-board-top-filter{
          position: absolute;
          left: 20px;
          bottom: 10px;
          display: flex;
          align-items: center;
          background: rgba(31,51,141,0.57);
          border-radius: 4px;
          .filter-btn{
            padding: 9px 15px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #C1ECFF;
            cursor: pointer;
          }
          .is-select{
            background: #2B7FFF;
            border-radius: 4px;
            color: #FFFFFF;
          }
        }
    }
    .sy-data-board-box{
        padding: 0 20px;
        display: flex;
        background-color: rgba(6,17,52,0.8);
        .sy-data-board-box-left{
            width: calc(25% - 10px);
        }
        .sy-data-board-box-center{
            width: calc(50% - 20px);
            margin: 0 20px;
            .sy-data-box-layout{
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
        }
        .sy-data-board-box-right{
            width: calc(25% - 10px);
        }
    }
}
</style>